import Store from '@/store'
import { Model } from '@vuex-orm/core'
import Shop from './ShopModel'
import { format, roundToNearestMinutes, addWeeks } from 'date-fns'
import { utcToLocal, localToUtc } from '@/utils/utcConverter'
import addClassesToModelHeaders from '@/utils/addClassesToModelHeaders'

import { dateAndTimeSlashes, dateAndTime } from '@/constants/TimeFormats'
import FieldTypes from '@/constants/FieldTypes'

export default class AvailabilityModel extends Model {
  static entity = 'availabilities'

  static nameSingular = 'Availability'
  static namePlural = 'Availabilities'

  static fields() {
    return {
      id: this.uid(),
      name: this.attr(''),
      shop_id: this.attr(null),
      shop: this.belongsTo(Shop, 'shop_id'),
      delivery_slots: this.attr(() => []),
      pickup_slots: this.attr(() => []),
      start_time: this.attr(() =>
        localToUtc(
          format(
            roundToNearestMinutes(new Date(), { nearestTo: 15 }),
            dateAndTime
          )
        )
      ),
      end_time: this.attr(() =>
        localToUtc(
          format(
            addWeeks(roundToNearestMinutes(new Date(), { nearestTo: 15 }), 1),
            dateAndTime
          )
        )
      ),
    }
  }

  static field_headers() {
    let headers = [
      {
        text: 'Name',
        align: 'start',
        sortable: true,
        value: 'name',
        sticky: true,
      },
      {
        text: 'Start Time',
        value: 'start_time',
        width: 220,
        sortable: true,
        sortKey: 'start_date',
        type: FieldTypes.DATETIME,
      },
      {
        text: 'End Time',
        value: 'end_time',
        width: 220,
        sortable: true,
        sortKey: 'end_date',
        type: FieldTypes.DATETIME,
      },
      {
        text: 'Delivery Slots',
        value: 'delivery_slots',
        type: FieldTypes.MULTISELECT,
        width: 300,
      },
      {
        text: 'Pickup Slots',
        value: 'pickup_slots',
        type: FieldTypes.MULTISELECT,
        width: 300,
      },
    ]
    return addClassesToModelHeaders(headers)
  }

  static index_table_config() {
    return {
      dense: false,
    }
  }

  static index_quick_links() {
    return [
      {
        title: 'Active',
        query: { filters: { active: 1 } },
        default: true,
      },
      {
        title: 'Future',
        query: { filters: { future: 1 } },
      },
      {
        title: 'Expired',
        query: { filters: { expired: 1 } },
      },
    ]
  }

  get start_time_in_local_tz() {
    return utcToLocal(this.start_time)
  }

  get start_time_formatted() {
    return format(this.start_time, dateAndTimeSlashes)
  }

  get end_time_in_local_tz() {
    return utcToLocal(this.end_time)
  }

  get end_time_formatted() {
    return format(this.end_time, dateAndTimeSlashes)
  }

  static indexUpcomingForShop(shopSlug) {
    const uri = `/shops/slug/${shopSlug}/${this.uri_path || this.entity}`
    return this.api().get(uri, { dataKey: 'data' })
  }

  static clone(availabilityId) {
    const shopId = Store.getters['shop/getShopId']
    return this.api().post(
      `/shops/${shopId}/availabilities/${availabilityId}/clone`
    )
  }
}
